const verification_record = {
    not_found: 'No se encontró el registro de verificación.',
    permission_denied: 'Permiso denegado, por favor vuelve a autenticarte.',
    not_supported_for_google_one_tap: 'Esta API no es compatible con Google One Tap.',
};
export default Object.freeze(verification_record);
